export default __webpack_public_path__ + "static/media/washerbefore.cae924b0.jpg";